import { VisualizationType, VisualizationScope, getVisualizationScope } from '../../../types';
import type { ISceneRenderer } from './ISceneRenderer';
import { DepartureBoardRenderer } from './DepartureBoardRenderer';

/**
 * Factory for SCENE-scoped (canvas-wide) renderers, keyed by VisualizationType.
 *
 * Only visualization types whose scope is SCENE (see VISUALIZATION_SCOPES) need
 * an entry here. Per-person visualizations are built by RendererFactory instead.
 *
 * Mapping:
 * - DEPARTURE_BOARD -> DepartureBoardRenderer (split-flap railway board)
 */
const SCENE_RENDERER_BUILDERS: Partial<Record<VisualizationType, () => ISceneRenderer>> = {
  [VisualizationType.DEPARTURE_BOARD]: () => new DepartureBoardRenderer(),
};

/**
 * Whether the given visualization type is rendered as a canvas-wide scene.
 */
export function isSceneVisualization(type: VisualizationType): boolean {
  return getVisualizationScope(type) === VisualizationScope.SCENE;
}

/**
 * Create a new scene renderer for the given visualization type, or null if the
 * type is not scene-scoped (i.e. it should be handled per-person).
 */
export function createSceneRenderer(type: VisualizationType): ISceneRenderer | null {
  const builder = SCENE_RENDERER_BUILDERS[type];
  return builder ? builder() : null;
}
